import { useState } from "react";
import "./style.scss";

const Menu = () => {
  const [isOpen, setOpen] = useState(false);

  return (
    <div className="menu">
      <button
        className={`menu__burger ${isOpen ? "menu__burger--open" : ""}`}
        onClick={() => setOpen((prev) => !prev)}
        aria-label="Toggle menu"
      >
        <span />
        <span />
        <span />
      </button>

      <ul className={isOpen ? "menu__links--open" : ""}>
        <li data-text="Home">
          <a href="#home" onClick={() => setOpen(false)}>Home</a>
        </li>
        <li data-text="About">
          <a href="#about" onClick={() => setOpen(false)}>About</a>
        </li>
        <li data-text="Projects">
          <a href="#projects" onClick={() => setOpen(false)}>Projects</a>
        </li>
        <li data-text="Contact">
          <a href="#contact" onClick={() => setOpen(false)}>Contact</a>
        </li>
      </ul>
    </div>
  );
};

export default Menu;
